<script>
import Layout from '@layouts/main'

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

import agronomo from '@/src/services/agronomo'
import formAgronomo from '@/src/components/form-agronomo'
import importAgronomo from '@/src/components/import-agronomo'
import * as XLSX from 'xlsx'

/**
 * agronomo Component
 */
export default {
  components: {
    Layout,
    Loading,
    formAgronomo,
    importAgronomo,
  },
  data() {
    return {
      agronomoEdit: {},
      agronomos: [],
      agronomoForm: true,
      idUserDelete: '',
      modal: false,
      modalImport: false,
      modalImportArtLote: false,
      isLoading: true,
      filter: '',
      artPrimaria: '',
      nReceitasArt: '',
      artImpressao: '',
      ultimaReceita: null,
      artBatchFile: null,
      isBatchProcessing: false,
      batchResult: null,
      agronomoFields: [
        {
          key: 'id_agronomo',
          label: 'ID'
        },
        {
          key: 'nome',
          label: 'Nome'
        },
        {
          key: 'n_receitas_art',
          label: 'Receitas Por ART'
        },
        {
          key: 'ultima_receita',
          label: 'Última Receita Emitida'
        },
        {
          key: 'receita_art_disponivel',
          label: 'Receita Disponível',
        },
        { key: 'actions', label: '' },
      ],
      currentPage: 1,
      perPage: 20,
    }
  },
  computed: {
    rows() {
      return this.agronomos.length
    },
  },
  watch: {
    agronomoForm() {
      if (this.agronomoForm) {
        this.listando()
      }
    },
  },
  mounted() {
    this.listando()
  },
  methods: {
    listando() {
      this.isLoading = true
      const token = this.$store.state.auth.currentUser.token
      agronomo
        .listar(token)
        .then((resposta) => {
          this.agronomos = resposta.data.data
          this.isLoading = false
        })
        .catch((error) => {
          this.isLoading = false
        })
    },
    listandoByFilter() {
      if (this.filter != undefined) {
        const token = this.$store.state.auth.currentUser.token
        this.isLoading = true
        agronomo
          .listarByFilter(token, this.filter)
          .then((resposta) => {
            this.agronomos = resposta.data.data
            this.isLoading = false
          })
          .catch((error) => {
            this.agronomos = []
            this.isLoading = false
          })
      } else {
        this.listando()
      }
    },
    openModal(item) {
      this.idUserEdit = item
      this.$bvModal.show('modal-modificar-receita');
    },
    closeModal() {
      this.$bvModal.hide('modal-modificar-receita');
    },
    openImportArtLote() {
      this.modalImportArtLote = true
      this.batchResult = null
    },
    resetBatchState() {
      this.artBatchFile = null
      this.isBatchProcessing = false
      this.batchResult = null
    },
    normalizeHeader(value) {
      if (!value) return ''
      return String(value)
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/\s+/g, '_')
        .replace(/[^\w]/g, '')
    },
    normalizeRow(rawRow) {
      const normalized = {}
      Object.keys(rawRow || {}).forEach((key) => {
        normalized[this.normalizeHeader(key)] = rawRow[key]
      })
      return {
        id_agronomo: normalized.id_agronomo || normalized.id || '',
        nome: normalized.nome || '',
        art_primaria: normalized.art_primaria || normalized.art || '',
        n_receitas_art:
          normalized.n_receitas_art || normalized.qtde_receita_art || normalized.receitas_por_art || '',
        ultima_receita: normalized.ultima_receita || normalized.numeracao_receita || '',
        art_impressao:
          normalized.art_impressao || normalized.base_numeracao_receita_cfta || normalized.complemento || '',
      }
    },
    getAgronomoIdByRow(row) {
      const rawId = row.id_agronomo
      if (rawId !== '' && rawId !== null && rawId !== undefined) {
        const parsed = Number(rawId)
        if (!Number.isNaN(parsed) && parsed > 0) {
          return parsed
        }
      }

      if (!row.nome) return null
      const target = String(row.nome).trim().toLowerCase()
      const found = this.agronomos.find((item) => String(item.nome || '').trim().toLowerCase() === target)
      return found ? found.id_agronomo : null
    },
    createBatchPayload(row) {
      const payload = {}
      if (String(row.art_primaria || '').trim()) {
        payload.art_primaria = String(row.art_primaria).trim()
      }
      if (String(row.art_impressao || '').trim()) {
        payload.art_impressao = String(row.art_impressao).trim()
      }
      if (row.n_receitas_art !== '' && row.n_receitas_art !== null && row.n_receitas_art !== undefined) {
        const nReceitas = Number(row.n_receitas_art)
        if (!Number.isNaN(nReceitas)) {
          payload.n_receitas_art = nReceitas
        }
      }
      if (row.ultima_receita !== '' && row.ultima_receita !== null && row.ultima_receita !== undefined) {
        const ultima = Number(row.ultima_receita)
        if (!Number.isNaN(ultima)) {
          payload.ultima_receita = ultima
        }
      }
      return payload
    },
    readBatchFile(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = (event) => {
          try {
            const data = event.target.result
            const workbook = XLSX.read(data, { type: 'array' })
            const sheetName = workbook.SheetNames[0]
            const sheet = workbook.Sheets[sheetName]
            const rows = XLSX.utils.sheet_to_json(sheet, { defval: '' })
            resolve(rows.map((row) => this.normalizeRow(row)))
          } catch (error) {
            reject(error)
          }
        }
        reader.onerror = () => reject(new Error('Falha ao ler o arquivo.'))
        reader.readAsArrayBuffer(file)
      })
    },
    async processArtBatchImport() {
      if (!this.artBatchFile) {
        this.$bvToast.toast('Selecione uma planilha para importar.', {
          variant: 'warning',
          solid: false,
          noCloseButton: true,
          toaster: 'b-toaster-top-center',
        })
        return
      }

      const token = this.$store.state.auth.currentUser.token
      this.isBatchProcessing = true
      this.batchResult = null

      try {
        const rows = await this.readBatchFile(this.artBatchFile)
        if (!rows.length) {
          this.$bvToast.toast('A planilha não contém linhas para processamento.', {
            variant: 'warning',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
          this.isBatchProcessing = false
          return
        }

        let success = 0
        let failed = 0
        const errors = []

        for (let index = 0; index < rows.length; index += 1) {
          const row = rows[index]
          const line = index + 2
          const id = this.getAgronomoIdByRow(row)

          if (!id) {
            failed += 1
            errors.push(`Linha ${line}: Agrônomo não encontrado (id/nome).`)
            continue
          }

          const payload = this.createBatchPayload(row)
          if (!Object.keys(payload).length) {
            failed += 1
            errors.push(`Linha ${line}: sem dados válidos para atualizar.`)
            continue
          }

          try {
            // Processamento sequencial para evitar sobrecarga da API.
            await agronomo.editarART(id, token, payload)
            success += 1
          } catch (error) {
            failed += 1
            const msg =
              (error.response && error.response.data && (error.response.data.msg || error.response.data.message)) ||
              'falha na atualização'
            errors.push(`Linha ${line}: ${msg}.`)
          }
        }

        this.batchResult = {
          total: rows.length,
          success,
          failed,
          errors: errors.slice(0, 20),
        }

        this.$bvToast.toast(`Importação concluída. Sucesso: ${success} | Falhas: ${failed}`, {
          variant: failed ? 'warning' : 'success',
          solid: false,
          noCloseButton: true,
          toaster: 'b-toaster-top-center',
        })

        this.listando()
      } catch (error) {
        this.$bvToast.toast(
          'Não foi possível ler a planilha. Verifique o formato e tente novamente.',
          {
            variant: 'danger',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          }
        )
      } finally {
        this.isBatchProcessing = false
      }
    },
    downloadBatchTemplate() {
      const headers = ['id_agronomo', 'nome', 'art', 'qtde_receita_art', 'numeracao_receita', 'base_numeracao_receita_cfta']
      const escapeCsv = (value) => {
        if (value === null || value === undefined) return ''
        const str = String(value)
        if (str.includes(',') || str.includes('"') || str.includes('\n')) {
          return `"${str.replace(/"/g, '""')}"`
        }
        return str
      }

      const rows = this.agronomos.length
        ? this.agronomos.map((item) => [
            item.id_agronomo || '',
            item.nome || '',
            '',
            '',
            '',
            '',
          ])
        : [['1', 'Nome do Tecnico', '', '', '', '']]

      const csvLines = rows.map((row) => row.map((col) => escapeCsv(col)).join(','))
      const csv = `${headers.join(',')}\n${csvLines.join('\n')}`
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'modelo_importacao_art_lote.csv')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    },
    submitForm() {
      const data = {};

      if (String(this.artPrimaria || '').trim()) {
        data.art_primaria = String(this.artPrimaria).trim();
      }

      if (this.nReceitasArt !== null && this.nReceitasArt !== undefined && String(this.nReceitasArt).trim() !== '') {
        data.n_receitas_art = Number(this.nReceitasArt);
      }

      if (this.ultimaReceita !== null && this.ultimaReceita !== undefined && String(this.ultimaReceita).trim() !== '') {
        data.ultima_receita = Number(this.ultimaReceita);
      }

      if (String(this.artImpressao || '').trim()) {
        data.art_impressao = String(this.artImpressao).trim();
      }

      const idUser = this.idUserEdit;
      const token = this.$store.state.auth.currentUser.token;

      this.isLoading = true;

      agronomo.editarART(idUser, token, data)
        .then(() => {
          this.closeModal();
          this.listando();

          this.artPrimaria = "";
          this.nReceitasArt = null;
          this.artImpressao = "";
          this.ultimaReceita = null;
        })
        .catch(() => {
          this.$bvToast.toast(
            'Ocorreu um erro ao editar, verifique os campos e tente novamente.',
            {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            }
          );
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    abrirForm() {
      if (this.agronomoForm === true) {
        this.agronomoForm = false
      } else {
        this.agronomoForm = true
        this.agronomoEdit = {}
      }
    },
    editRegister(agronomo) {
      this.agronomoEdit = agronomo
      console.log(agronomo)
      this.agronomoForm = false
    },
    modalDelete(item) {
      this.modal = true
      this.idUserDelete = item
    },
    handleDelete() {
      const token = this.$store.state.auth.currentUser.token
      agronomo
        .deleteAgronomo(token, this.idUserDelete)
        .then((reposta) => {
          this.listando()
        })
        .catch((err) => {
          this.isLoading = this.loading(this.isLoading)
          this.$bvToast.toast(
            'Ocorreu um erro ao deletar, verifique se o item está sendo utilizado em outro lugar.',
            {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            }
          )
        })
      this.idUserDelete = null
      this.modal = false
    },
  },
}
</script>
<template>
  <Layout>
    <div class="bloco">
      <div>
        <div class="row">
          <div class="col-md-11">
            <div class="titulo">Responsável Técnico</div>
            <div class="subTitulo">Visualize, edite e cadastre novos Responsáveis Técnicos na plataforma.</div>
          </div>
          <div class="col-md-1">
            <div class="float-right">
              <button class="btn btn-primary" @click="abrirForm">
                <span v-if="agronomoForm">Novo</span>
                <span v-else>Ver todos</span>
              </button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="borda"></div>
          </div>
        </div>
        <div v-if="agronomoForm" class="row align-items-end agronomo-toolbar">
          <div class="col-12 col-md-5 col-lg-4">
            <b-form-group id="input-group-1" label="Nome" label-for="filter">
              <b-form-input id="filter" v-model="filter" type="text"></b-form-input>
            </b-form-group>
          </div>
          <div class="col-12 col-md-auto mb-3">
            <button class="btn btn-primary w-100 w-md-auto" @click="listandoByFilter">Pesquisar</button>
          </div>
          <div class="col-12 col-md actions-col mb-3">
            <div class="toolbar-actions">
              <button class="btn btn-outline-primary" @click="modalImport = true">Importar</button>
              <button class="btn btn-primary" @click="openImportArtLote">Importar ART em lote</button>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div v-if="agronomoForm">
          <b-table striped hover responsive="sm" borderless bordered outlined small :items="agronomos"
            :fields="agronomoFields" :current-page="currentPage" :per-page="perPage">
            <template v-slot:cell(actions)="row">
              <div class="btn-group mb-2">
                <b-dropdown v-b-tooltip.hover size="md" variant="link" toggle-class="text-decoration-none" no-caret
                  title="Edite ou Delete o Responsável Técnico">
                  <template v-slot:button-content>
                    <i class="uil uil-ellipsis-v"></i>
                  </template>
                  <b-dropdown-item @click="editRegister(row.item)">Editar</b-dropdown-item>
                  <b-dropdown-item @click="modalDelete(row.item.id_agronomo)">Excluir</b-dropdown-item>
                  <b-dropdown-item @click="openModal(row.item.id_agronomo)">Incluir ART</b-dropdown-item>
                </b-dropdown>
              </div>
            </template>
          </b-table>
          <b-pagination v-model="currentPage" size="md" :total-rows="rows" :per-page="perPage"></b-pagination>
        </div>
        <div v-else>
          <formAgronomo :agronomo="agronomoEdit" />
        </div>
      </div>

      <div class="borda"></div>
    </div>
    <b-modal v-model="modal" title="Aviso" title-class="font-18">
      <p>Tem certeza que deseja excluir este registro?</p>
      <template v-slot:modal-footer>
        <b-button variant="light" @click="modal = false">Não</b-button>
        <b-button variant="danger" @click="handleDelete">Sim</b-button>
      </template>
    </b-modal>

    <b-modal v-model="modalImport" size="lg" title="Importação de Agrônomos" title-class="font-18" @hide="listando">
      <importAgronomo></importAgronomo>
      <template v-slot:modal-footer>
        <b-button variant="primary" @click="modalImport = false">Sair</b-button>
      </template>
    </b-modal>

    <b-modal v-model="modalImportArtLote" size="lg" title="Importar ART em lote" title-class="font-18"
      @hide="resetBatchState">
      <div class="mb-2 text-muted">
        Envie uma planilha (<code>.xlsx</code>, <code>.xls</code> ou <code>.csv</code>) com as colunas:
        <code>id_agronomo</code> ou <code>nome</code>, <code>art</code>, <code>qtde_receita_art</code>,
        <code>numeracao_receita</code>, <code>base_numeracao_receita_cfta</code>.
      </div>
      <div class="mb-3">
        <b-button size="sm" variant="outline-primary" @click="downloadBatchTemplate">
          Baixar modelo de planilha
        </b-button>
      </div>

      <b-form-file v-model="artBatchFile" :disabled="isBatchProcessing" accept=".xlsx,.xls,.csv"
        browse-text="Selecionar arquivo" placeholder="Nenhum arquivo selecionado"></b-form-file>

      <div v-if="batchResult" class="mt-3">
        <p class="mb-1"><strong>Processadas:</strong> {{ batchResult.total }}</p>
        <p class="mb-1 text-success"><strong>Sucesso:</strong> {{ batchResult.success }}</p>
        <p class="mb-2 text-danger"><strong>Falhas:</strong> {{ batchResult.failed }}</p>
        <div v-if="batchResult.errors.length" class="batch-errors">
          <div v-for="(error, idx) in batchResult.errors" :key="`batch-error-${idx}`">
            {{ error }}
          </div>
        </div>
      </div>

      <template v-slot:modal-footer>
        <b-button variant="light" :disabled="isBatchProcessing" @click="modalImportArtLote = false">Fechar</b-button>
        <b-button variant="primary" :disabled="!artBatchFile || isBatchProcessing" @click="processArtBatchImport">
          <span v-if="!isBatchProcessing">Processar planilha</span>
          <b-spinner v-else small></b-spinner>
        </b-button>
      </template>
    </b-modal>

    <b-modal id="modal-modificar-receita" title="Incluir ART">
      <b-form>

        <b-form-group id="input-group-1" label="ART" label-for="input-1">
          <b-form-input id="input-1" v-model="artPrimaria" type="text" placeholder="Informe sua ART" autofocus
            required />
        </b-form-group>

        <b-form-group id="input-group-2" label="Número de Receitas Por ART" label-for="input-2">
          <b-form-input id="input-2" v-model="nReceitasArt" type="number" placeholder="Informe o nº de receitas por ART"
            required />
        </b-form-group>

        <b-form-group id="input-group-3" label-for="input-3">
          <template v-slot:label>
            Complemento do número
            <b-icon v-b-tooltip.hover role="button"
              title="O campo deve ser preenchido para complementar o número da receita ex: BR202203RA"
              icon="exclamation-circle-fill" variant="info" />
          </template>
          <b-form-input id="input-3" v-model="artImpressao" v-no-autocomplete type="text"
            placeholder="Complemento do número" required />
        </b-form-group>

        <b-form-group id="group-ultima-receita" label="Última Receita Emitida" label-for="input-ultima-receita">
          <b-form-input id="input-ultima-receita" v-model="ultimaReceita" type="number"
            placeholder="Informe qual foi a última receita emitida" required />
        </b-form-group>

      </b-form>

      <template v-slot:modal-footer>
        <b-button variant="secondary" @click="closeModal">Cancelar</b-button>
        <b-button variant="primary" @click="submitForm">Salvar</b-button>
      </template>
    </b-modal>

    <b-overlay :show="isLoading" no-wrap>
    </b-overlay>
  </Layout>
</template>
<style lang="scss">
.bloco {
  margin-top: 30px;
  background-color: #fff;
  padding: 40px;
  border-radius: 0.25rem;

  .titulo {
    font-size: 25px;
    color: #008e75;
    margin-bottom: 10px;
    font-weight: bold;
  }

  .subtitulo {
    margin-bottom: 10px;
  }

  .borda {
    margin-top: 15px;
    margin-bottom: 15px;
    border-bottom: solid 1px #edeff4;
  }

  .formulario {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .btn-webreceita {
    margin-top: 30px;
    margin-bottom: 10px;
    background-color: #008e75;
    padding: 5px 30px;

    &.botaoTopo {
      float: right;
    }
  }

  .filterButton {
    background-color: #008e74c7;
    padding: 0 20px;
  }

  .cadastra {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .agronomo-toolbar {
    margin-bottom: 8px;
  }

  .actions-col {
    display: flex;
    justify-content: flex-end;
  }

  .toolbar-actions {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    justify-content: flex-end;
  }

  @media (max-width: 767px) {
    .actions-col {
      justify-content: flex-start;
    }

    .toolbar-actions {
      width: 100%;
      justify-content: flex-start;
    }
  }

  .batch-errors {
    max-height: 160px;
    overflow-y: auto;
    border: 1px solid #e3e7ee;
    border-radius: 4px;
    padding: 8px;
    font-size: 13px;
    background: #fafbfc;
  }
}
</style>
